import { combineReducers } from '@reduxjs/toolkit'

// Import feature reducers
import authReducer from '@/features/auth/authSlice'
import applicationReducer from '@/features/applicant/applicationSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  application: applicationReducer,
})

export default rootReducer

